import { useTranslation, Trans } from 'react-i18next'
import { History } from 'history'
import { MessageModal } from '@/components/message-modal'
import { Contract } from '@/features/Pad'
import { createModal, useModalize } from '@/components/modalize/mui'

type DeletePadProps = {
  contracts?: Contract[]
  history: History
}

const DeletePadErrorModal: React.FC<DeletePadProps> = ({ contracts = [], history }) => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const hasMultiple = contracts.length > 1
  const streetAddress = contracts[0]?.full_street_name
  const listingId = contracts[0]?.listing_id

  const handleClick = () => {
    if (hasMultiple) {
      history.push(`/rentals/`)
    } else {
      history.push(`/rental/${listingId}/payments/`)
    }
    close()
  }

  const messageText = hasMultiple ? (
    <Trans i18nKey="l.payment_settings.edit.delete_pad_error_plural.text">
      You have automated rent payments (PAD) set up for multiple rentals. Please select the{' '}
      <strong>Stop PAD</strong> button for each one from your{' '}
      <button onClick={handleClick}>payment settings</button> before deleting your bank account.
    </Trans>
  ) : (
    <Trans i18nKey="l.payment_settings.edit.delete_pad_error.text">
      You have an automated rent payment (PAD) set up for {{ streetAddress }}. Please select the{' '}
      <strong>Stop PAD</strong> button from your{' '}
      <button onClick={handleClick}>payment settings</button> before deleting your bank account.
    </Trans>
  )

  return (
    <MessageModal
      icon="warning"
      title={t('l.payment_settings.edit.delete_pad_error.title', 'Unable to Delete Account')}
      message={messageText}
    />
  )
}

const show = createModal(DeletePadErrorModal, {
  width: '496px'
})

export default show
